import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Foreground = ApplicationRecord.extend({
  static: {
    jsonapiType: 'foregrounds',
  },
  attrs: {
    color: attr(),
    imageUrl: attr(),
    senior: attr(),
    studentId: attr(),
    season: attr(),
  },
});

export default Foreground;
